module.exports = __webpack_public_path__ + "img/seller1.025a42ed.png";